import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useTheme } from '@mui/system'
import { Grid, useMediaQuery } from '@mui/material'
import { cx } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import ArrowheadLeftIcon from '../../atoms/icons/arrowhead-left-icon'
import StoreLocatorDetailsGallery from '../../molecules/store-locator/details/gallery'
import StoreLocatorDetailsInfo from '../../molecules/store-locator/details/info'
import NearbyStores from '../../organisms/nearby-stores'
import { BackButton, Content, InnerContent } from './store-locator-details.styled'

const StorelocatorDetailPageComponent = ({ /* entityId, code, dynamicAreas, sku, type, */ ...props }) => {
	const {
		id,
		title,
		latitude,
		longitude,
		street,
		postcode,
		city,
		countryCode,
		phone1,
		phone2,
		email,
		websiteUrl,
		region,
		image,
		images,
		workingTimes,
		additionalText,
		additionalText2,
	} = props || {}

	const theme = useTheme()
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'))

	const {
		storelocator: {
			path: storeLocatorPath,
			nearbyStores: { enabled: nearbyStoresEnabled },
		},
	} = useConfig()

	const Back = () => (
		<BackButton
			href={{
				pathname: storeLocatorPath,
				query: { store: encodeURIComponent(id) },
			}}
			color="grey.main"
			underline="none"
		>
			<ArrowheadLeftIcon color="primary" />
			<FormattedMessage id="store_locator_detail_back" />
		</BackButton>
	)

	return (
		<Grid container spacing={0} className={cx('StoreLocatorDetails-root')} id={`store_id_${id}`}>
			<Grid item xs={12}>
				{!lgUp && (
					<Grid container spacing={0}>
						<Grid item xs={12}>
							<Back />
						</Grid>
					</Grid>
				)}
			</Grid>
			{(images?.length || image) && (
				<Grid item xs={12} lg={7}>
					<StoreLocatorDetailsGallery images={images} image={image} />
				</Grid>
			)}
			<Content item xs={12} lg={images?.length > 1 || image ? 5 : 12}>
				<Grid container spacing={3}>
					{lgUp && (
						<Grid item xs={12}>
							<Back />
						</Grid>
					)}
					<InnerContent item xs={12} hasImages={images?.length > 1 || image || false}>
						<StoreLocatorDetailsInfo
							store={{
								title,
								latitude,
								longitude,
								street,
								postcode,
								city,
								countryCode,
								phone1,
								phone2,
								email,
								websiteUrl,
								region,
								workingTimes,
								additionalText,
								additionalText2,
							}}
						/>
					</InnerContent>
				</Grid>
			</Content>
			{nearbyStoresEnabled && (
				<Grid item xs={12} p={5}>
					<NearbyStores latitude={latitude} longitude={longitude} currentStore={id} />
				</Grid>
			)}
		</Grid>
	)
}

export default StorelocatorDetailPageComponent
